"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementWidth = useElementWidth;
var _react = require("react");
var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));
function useElementWidth(elementRef) {
  var _ref = (0, _react.useState)(0),
    _ref2 = _slicedToArray(_ref, 2),
    elementWidth = _ref2[0],
    setElementWidth = _ref2[1];
  var resizeCallback = (0, _react.useCallback)(function () {
    if (elementRef.current) {
      var toolbar = elementRef.current;
      setElementWidth(toolbar.clientWidth);
    }
  }, [elementRef]);
  (0, _resizeObserver.default)(elementRef, resizeCallback);
  return elementWidth;
}